<template>
  <div class="additional-info">
    <SectionHeader title="Additional Info" :extra-class="['text-left']" />
    <div class="info-list">
      <span v-html="InfoData" />
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
export default {
  name: "AdditionalInfo",
  components: {
    SectionHeader
  },
  props: {
    InfoData: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.additional-info {
  .section-header {
    margin-bottom: 30px !important;
  }
  .info-list {
    span {
      margin-bottom: 30px;
      p {
        font-family: $content-font;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 0px;
        overflow-wrap: break-word;
      }
    }
  }
}
</style>
